<template>
  <div class="ly-col ly-center-center reset-password-container">
    <img src="@/assets/img/lp-logo-white.svg" class="mb-3" />
    <div class="card">
      <h3>Set New Password</h3>
      <div class="msg">Now that you've confirmed your email, please enter a new password twice below.</div>

      <form @submit.prevent="formSubmitted" class="form-reset-password">
        <lp-input v-model="newPassword" type="password" label-top="New password" />
        <lp-input v-model="repeatPassword" type="password" label-top="Confirm password" compact />
        <PasswordPoliciesList :isSymbolsPolicyMeet="isSymbolsPolicyMeet" :isLengthPolicyMeet="isLengthPolicyMeet"
          :isLowercasePolicyMeet="isLowercasePolicyMeet" :isRequireNumberPolicyMeet="isRequireNumberPolicyMeet"
          :isUppercasePolicyMeet="isUppercasePolicyMeet"></PasswordPoliciesList>
        <div class="ly-row mt-2">
          <lp-button :disabled="disableSubmitButton" :loading="submitting" type="primary" class="btn-loading-active">Submit</lp-button>
        </div>
      </form>
      <div v-if="errorMessage">
        <div class="">{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import { ref, computed, inject, Ref } from 'vue'
import PasswordPoliciesList from '@/views/Common/components/PasswordPoliciesList.vue'
import { useConfigSync } from '@/config/useConfig'

const newPassword: Ref<string> = ref('')
const repeatPassword: Ref<string> = ref('')
const config = useConfigSync()
const resetPasswordHashFlow = inject('resetPasswordHashFlow') as (newPassword: string, hashedPassword: string) => Promise<void>
const getQueryParameter = inject('getQueryParameter') as (paramName: string) => string
const submitting: Ref<boolean> = ref(false)
const errorMessage: Ref<string> = ref('')

const formSubmitted = async () => {
  if (submitting.value || !isNewPasswordValid()) return

  submitting.value = true
  try {
    await resetPasswordHashFlow(newPassword.value, getQueryParameter('key'))
  } catch (error: any) {
    errorMessage.value = error.message
  }
  submitting.value = false
}

const isNewPasswordValid = () => {
  if (newPassword.value && repeatPassword.value && newPassword.value === repeatPassword.value) {
    return true
  } else {
    return false
  }
}

const disableSubmitButton = computed(() => !isNewPasswordValid() || submitting.value)

const isSymbolsPolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_symbols) return true
  return (/[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/.test(newPassword.value))
})

const isLengthPolicyMeet = computed((): boolean => {
  return newPassword.value.length >= config?.password_policy.minimum_length
})

const isLowercasePolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_lowercase) return true
  return (/[a-z]/.test(newPassword.value))
})

const isRequireNumberPolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_numbers) return true
  return /\d/.test(newPassword.value)
})

const isUppercasePolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_uppercase) return true
  return (/[A-Z]/.test(newPassword.value))
})

</script>

<style>
.form-reset-password {
  padding: 0px;
  margin: 0px;
}

.reset-password-container {
  height: 100%;
  background: #354255;
}

.reset-password-container .card {
  width: 550px;
}

.reset-password-container img {
  width: 200px;
}
</style>
